import { render } from "./NotificationComp.vue?vue&type=template&id=0e41c3c8"
import script from "./NotificationComp.vue?vue&type=script&lang=js"
export * from "./NotificationComp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__